export default "__VITE_ASSET__C55h4EmZ__"